import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DividendCalculatorPage from "@/components/tools/DividendCalculatorPage";

const DividendCalculator = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    // First-visit default: English. Respect any prior user choice.
    if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage("en");
    }
  }, [i18n]);
  return <DividendCalculatorPage locale="en" />;
};

export default DividendCalculator;
